import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../util/util'

const slice = createSlice({
	name: 'exerciseRecorder',
	initialState : {
		show:false,
		//will be set_id or exercise_id
		exercise_id:null,
		exercise_type:null,
		workout_id:null,
		setIdx:0
	},
	reducers : {
		toggleShow: state => {
			const show = !state.show
			state.show = show
			if (!show){
				state.exercise_id = null
				state.workout_id = null
			}
		},

		setData : (state,action) => {
			Object.entries(action.payload).forEach(([k,v])=>{
				state[k] = v
			})
		}
	},
	extraReducers : {}
})

export const {toggleShow,setData} = slice.actions

export const selectShow = state => state.exerciseRecorder.show
export const selectType = state => state.exerciseRecorder.type
export const selectExerciseId = state => state.exerciseRecorder.exercise_id
export const selectExerciseType = state => state.exerciseRecorder.exercise_type
export const selectWorkoutId = state => state.exerciseRecorder.workout_id
export const selectSetIdx = state => state.exerciseRecorder.setIdx

export default slice.reducer